/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// formik components
import { Formik, Form } from 'formik';

// @mui material components
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'components/DashboardNavbar';
import Footer from 'examples/Footer';

// NewUser page components

// NewUser layout schemas for form and form feilds
import { Can } from 'context';
import { Navigate } from 'react-router-dom';
import initialValues from 'layouts/operator-management/components/schemas/initialValues';
import form from '../components/schemas/form';
import validations from '../components/schemas/validations';
import OperatorInfo from '../components/OperatorInfo';
import { createOperator } from 'services/operators';
import { useToast } from 'context/ToastContext';
function NewOperator() {
  const { formId, formField } = form;
  const currentValidation = validations[0];

  const toast = useToast();

  const handleSubmit = async (values, actions) => {
    try {
      await createOperator(values);
      toast.success('Operator created successfully');
      actions.resetForm();
    } catch (err) {
      console.error(err);
      toast.error('Failed to create operator');
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      <Can I='create' a='operator'>
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox py={3} mb={20} height='65vh'>
            <Grid container justifyContent='center' alignItems='center' sx={{ height: '100%', mt: 8 }}>
              <Grid item xs={12} lg={8}>
                <Formik initialValues={initialValues} validationSchema={currentValidation} onSubmit={handleSubmit}>
                  {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                    <Form id={formId} autoComplete='off'>
                      <Card sx={{ height: '100%' }}>
                        <MDBox p={3}>
                          <MDBox>
                            <OperatorInfo
                              formData={{
                                values,
                                touched,
                                formField,
                                errors,
                                setFieldValue,
                                isSubmitting
                              }}
                            />
                            <MDBox mt={2} width='100%' display='flex' justifyContent='space-between'>
                              <MDButton disabled={isSubmitting} type='submit' variant='gradient' color='dark'>
                                Send
                              </MDButton>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </Form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </MDBox>
          <Footer />
        </DashboardLayout>
      </Can>
      <Can not I='create' a='operator'>
        <Navigate to='/dashboard' replace />
      </Can>
    </>
  );
}

export default NewOperator;
